var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bottom text-right mx-3 mb-2"},[_c('a',{attrs:{"href":"#home"}},[_c('mdb-btn',{staticClass:"btn-rounded animated bounce infinite",attrs:{"outline":"secondary"}},[_c('mdb-icon',{attrs:{"icon":"arrow-up"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }